// extracted by mini-css-extract-plugin
export var clinicDetails = "styles-module--clinicDetails--pn2Ef";
export var clinicInfo = "styles-module--clinicInfo--Ahpdq";
export var content = "styles-module--content--S8+0o";
export var directionsCta = "styles-module--directionsCta--xzaL-";
export var hoursOfOperation = "styles-module--hoursOfOperation--Lc55g";